import React, { Component } from "react";
import { Spinner } from "reactstrap";
import { showErrorMessage } from "services/utility";
import { withTranslation } from "react-i18next";
export class SelectGrades extends Component {
  constructor(props) {
    super(props);
  }
  state = {
    selectedGrade: "",
    spinnerForFeed: this.props.spinnerForFeed,
  };
  // componentWillReceiveProps() {
  //   this.setState({ spinnerForFeed: this.props.spinnerForFeed });
  // }

  selectGradeConvert(number) {
    switch (number) {
      case "1":
        return "I";
        break;
      case "2":
        return "II";
        break;
      case "3":
        return "III";
        break;
      case "4":
        return "IV";
        break;
      case "5":
        return "V";
        break;
      case "6":
        return "VI";
        break;
      case "7":
        return "VII";
        break;
      case "8":
        return "VIII";
        break;
      case "9":
        return "IX";
        break;
      case "10":
        return "X";
        break;
      case "11":
        return "XI";
        break;
      case "12":
        return "XII";
        break;
      default:
      // code block
    }
  }

  spinnerState() {
    this.setState({ spinnerForFeed: true });
  }

  onProceed() {
    if (this.state.selectedGrade.length > 0) {
      this.spinnerState();
      this.props.selectedgrade(this.state.selectedGrade);
    } else {
      showErrorMessage(
        this.props.t("onboarding.select_grade.please_select_grade"),
        1
      );
    }
  }

  render() {
    let selectedGradeState = async (value) => {
      await this.setState({ selectedGrade: value });
    };
    // let isDisable = !(this.state.selectedGrade.length > 0);

    return (
      <div className="m-auto loginCard">
        <div className="col-sm-12 m-auto text-center">
          <div className="row no-gutters my-auto">
            <div className="cardtitle text-center text-white ">
              {this.props.t("onboarding.select_grade.select_grade")}
            </div>
          </div>
          <div className="row my-2 ">
            <div className="col-sm-12 mx-auto">
            <div className="col-md-12 m-auto">
                <div className="form-group ">
                  <div className="row d-flex justify-content-center">
                    {window.activatedGradesList.map((element, i) => {
                      return (
                        <div
                          className="grade-item-flex"
                          onClick={(e) => {
                            selectedGradeState(element);
                          }}
                        >
                          <input
                            type="radio"
                            name="radio1"
                            id={this.selectGradeConvert(element)}
                            defaultValue={this.selectGradeConvert(element)}
                            // defaultChecked
                          />
                          <label
                            className="select-label"
                            htmlFor={this.selectGradeConvert(element)}
                          >
                            {this.selectGradeConvert(element)}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
                {!this.state.spinnerForFeed && (
                   <div className="col-md-7 m-auto">
                  <div className="form-group">
                    <button
                      type="button"
                      className="card-button"
                      // disabled={isDisable}
                      id
                      onClick={(e) => {
                        // this.props.hidefunction();
                        this.onProceed();
                      }}
                    >
                      {this.props.t("onboarding.select_grade.proceed")}
                    </button>
                  </div>
                  </div>
                )}
                {this.state.spinnerForFeed && (
                  <div className="text-center">
                    <Spinner
                      className=" "
                      animation="border"
                      style={{ color: "#1b1f5f" }}
                      size="lg"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(SelectGrades);
